module.exports = __webpack_public_path__ + "img/ico_saoyisao_fasong.521656a4.png";